import { ClassNames } from "@emotion/react";
import type { HTMLAttributes } from "react";

import { useTranslate } from "../../../utils/translate";
import type { CardOrientation, ImageProps } from "../Card";
import {
  CardContent,
  CardContentClassName,
  CardImage,
  DateLine,
  Root,
  StickyIcon,
  TitleLine,
} from "./styles";
import { translations } from "./translations";

export type OrientationProps = {
  /**
   * The component orientation.
   */
  orientation: CardOrientation;
};

type NewsCardProps = {
  /**
   * The string represents a date in a desired format.
   */
  date: string;
  /**
   * The component title.
   */
  title: string;
  /**
   * if the article should be displayed as sticky
   */
  isSticky?: boolean;
} & ImageProps &
  OrientationProps &
  HTMLAttributes<HTMLDivElement>;

/**
 * Element uses the Card entity and it's sub components to build a news article card.
 */
export function NewsCard({
  date,
  alt,
  src,
  orientation,
  title,
  isSticky = false,
  ...rest
}: NewsCardProps): JSX.Element {
  const t = useTranslate(translations);
  return (
    <ClassNames>
      {({ cx }) => (
        <Root data-testid={NewsCard.name} orientation={orientation} {...rest}>
          <CardImage alt={alt} src={src} orientation={orientation} />
          <CardContent orientation={orientation} className={cx(CardContentClassName)}>
            <TitleLine lines={2} title={title} align="left">
              {isSticky && <StickyIcon icon="pin" title={t("newsCard.sticky")} />}
              {title}
            </TitleLine>
            <DateLine>{date}</DateLine>
          </CardContent>
        </Root>
      )}
    </ClassNames>
  );
}
